module.exports = __webpack_public_path__ + "img/index_rctj.abcf0275.png";